var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySectionStanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2718 38.3553L42.8046 35.6638L27.5522 30.1684L14.2064 22.2058L11.8887 28.7479L23.5896 35.6638L41.2718 38.3553Z",
    fill: "#CECDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0969 50.8458L43.0233 46.1802L41.9174 46.2147L41.8848 50.1709L45.0969 50.8458Z",
    fill: "#817DB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6875 2.41992H69.0152V48.8071H61.6875V2.41992Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0469 60.2859H47.6395C49.8245 60.2859 51.5957 58.5147 51.5957 56.3297V54.0795C51.5957 51.8946 49.8245 50.1233 47.6395 50.1233H40.0469C37.862 50.1233 36.0907 51.8946 36.0907 54.0795V56.3297C36.0907 58.5147 37.862 60.2859 40.0469 60.2859Z",
    fill: "#817DB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4649 60.2859H50.0575C52.2424 60.2859 54.0137 58.5147 54.0137 56.3297V54.0795C54.0137 51.8946 52.2424 50.1233 50.0575 50.1233H42.4649C40.2799 50.1233 38.5087 51.8946 38.5087 54.0795V56.3297C38.5087 58.5147 40.2799 60.2859 42.4649 60.2859Z",
    fill: "#EAE9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0411 48.7667C73.8569 48.7667 84.2462 38.3774 84.2462 25.5616C84.2462 12.7457 73.8569 2.35645 61.0411 2.35645C48.2252 2.35645 37.8359 12.7457 37.8359 25.5616C37.8359 38.3774 48.2252 48.7667 61.0411 48.7667Z",
    fill: "#817DB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8672 48.8416C81.6831 48.8416 92.0723 38.4523 92.0723 25.6365C92.0723 12.8207 81.6831 2.4314 68.8672 2.4314C56.0514 2.4314 45.6621 12.8207 45.6621 25.6365C45.6621 38.4523 56.0514 48.8416 68.8672 48.8416Z",
    fill: "#A7A3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3555 39.631C51.8185 33.3334 69.0476 25.7283 69.0476 25.7283L60.7206 47.3705C56.6035 45.8222 53.0095 43.1387 50.3555 39.631Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9819 2.63904L69.0472 25.729L46.8223 18.3696C49.8712 9.11328 58.589 2.4336 68.8667 2.4336C69.9085 2.43293 70.9492 2.50156 71.9819 2.63904Z",
    fill: "#EAE9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7969 39.5795C45.323 36.9203 45.4218 33.7676 45.4218 33.7676C45.4218 33.7676 48.8366 31.3263 50.4695 30.1897C52.6286 28.6883 54.8577 31.4003 51.5255 32.8374C51.0666 37.2985 49.5191 37.3753 49.5191 37.3753",
    fill: "#817DB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.552 32.8064C51.552 32.8064 51.1805 36.3373 49.5293 37.3443",
    stroke: "#55489E",
    strokeWidth: 0.205516,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9304 46.5238C31.6582 42.3386 28.8613 36.8787 27.961 30.9662C27.0607 25.0538 28.1056 19.0089 30.9384 13.7417L36.2068 14.047L58.4788 27.007L41.1988 46.8252L35.9304 46.5238Z",
    fill: "#A7A3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1979 46.8336C36.9257 42.6484 34.1289 37.1885 33.2286 31.276C32.3282 25.3636 33.3731 19.3187 36.2059 14.0515L68.8795 25.6474L41.1979 46.8336Z",
    fill: "#3B377A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5234 57.9314H90.0997C92.0089 57.9314 93.5566 56.3839 93.5566 54.4749C93.5566 52.566 92.0089 51.0184 90.0997 51.0184H79.5234C77.6141 51.0184 76.0664 52.566 76.0664 54.4749C76.0664 56.3839 77.6141 57.9314 79.5234 57.9314Z",
    fill: "#817DB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3654 8.8501H38.4256C40.2012 8.8501 41.6406 7.41089 41.6406 5.63554C41.6406 3.86019 40.2012 2.42098 38.4256 2.42098H27.3654C25.5898 2.42098 24.1504 3.86019 24.1504 5.63554C24.1504 7.41089 25.5898 8.8501 27.3654 8.8501Z",
    fill: "#817DB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9433 57.9314H92.5196C94.4288 57.9314 95.9766 56.3839 95.9766 54.4749C95.9766 52.566 94.4288 51.0184 92.5196 51.0184H81.9433C80.034 51.0184 78.4863 52.566 78.4863 54.4749C78.4863 56.3839 80.034 57.9314 81.9433 57.9314Z",
    fill: "#EAE9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3999 51.4342L88.4086 47.1824L78.5234 39.3708",
    stroke: "#55489E",
    strokeWidth: 0.205516,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6699 5.8418H46.7902L54.0488 11.5797",
    stroke: "#55489E",
    strokeWidth: 0.205516,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3859 53.1963H81.5645H93.3859Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3859 53.1963H81.5645",
    stroke: "#55489E",
    strokeWidth: 0.205516,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3859 54.4409H81.5645H93.3859Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3859 54.4409H81.5645",
    stroke: "#55489E",
    strokeWidth: 0.205516,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3858 55.6855H88.4082H93.3858Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3858 55.6855H88.4082",
    stroke: "#55489E",
    strokeWidth: 0.205516,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7786 8.84082H39.6042C41.3772 8.84082 42.8145 7.40355 42.8145 5.63058V5.62962C42.8145 3.85665 41.3772 2.41938 39.6042 2.41938H29.7786C28.0056 2.41938 26.5684 3.85665 26.5684 5.62962V5.63058C26.5684 7.40355 28.0056 8.84082 29.7786 8.84082Z",
    fill: "#EAE9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4063 4.44189H29.4258",
    stroke: "#55489E",
    strokeWidth: 0.205516,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4063 5.59863H29.4258",
    stroke: "#55489E",
    strokeWidth: 0.205516,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4066 6.75391H35.7832",
    stroke: "#55489E",
    strokeWidth: 0.205516,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2172 54.2372C48.8906 54.2372 49.4364 53.6914 49.4364 53.018C49.4364 52.3447 48.8906 51.7988 48.2172 51.7988C47.5439 51.7988 46.998 52.3447 46.998 53.018C46.998 53.6914 47.5439 54.2372 48.2172 54.2372Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2446 58.6144C44.9179 58.6144 45.4638 58.0686 45.4638 57.3952C45.4638 56.7219 44.9179 56.176 44.2446 56.176C43.5712 56.176 43.0254 56.7219 43.0254 57.3952C43.0254 58.0686 43.5712 58.6144 44.2446 58.6144Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9791 58.1991C49.0835 58.1993 49.1856 58.1678 49.2718 58.1089C49.358 58.0499 49.4243 57.9662 49.4619 57.8687C49.4996 57.7713 49.5068 57.6648 49.4826 57.5631C49.4585 57.4615 49.4041 57.3696 49.3266 57.2996L43.9439 52.4343C43.8421 52.3424 43.7079 52.2947 43.5709 52.3017C43.4339 52.3087 43.3053 52.3699 43.2133 52.4717C43.1214 52.5736 43.0737 52.7078 43.0808 52.8448C43.0878 52.9818 43.1489 53.1104 43.2508 53.2023L48.6335 58.0666C48.728 58.1525 48.8514 58.1998 48.9791 58.1991Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2366 50.8459L43.057 46.2148L43.0234 50.171L46.2366 50.8459Z",
    fill: "#EAE9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8476 15.0023C87.444 15.0023 89.5487 12.8976 89.5487 10.3012C89.5487 7.70486 87.444 5.6001 84.8476 5.6001C82.2512 5.6001 80.1465 7.70486 80.1465 10.3012C80.1465 12.8976 82.2512 15.0023 84.8476 15.0023Z",
    fill: "#817DB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5703 5.6001H87.1277V15.0023H84.5703V5.6001Z",
    fill: "#817DB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4062 15.0023C90.0026 15.0023 92.1073 12.8976 92.1073 10.3012C92.1073 7.70486 90.0026 5.6001 87.4062 5.6001C84.8098 5.6001 82.7051 7.70486 82.7051 10.3012C82.7051 12.8976 84.8098 15.0023 87.4062 15.0023Z",
    fill: "#EAE9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9746 23.698C21.2996 25.3479 20.0922 29.5101 20.6622 32.9598C23.152 30.8 22.5745 25.8853 21.9746 23.698Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93814 95.9927L-0.111328 90.1806L5.59142 68.0276C5.6889 67.6489 5.73823 67.2595 5.73823 66.8685V45.8965H20.6246L12.7127 73.5319L5.73823 90.1806L6.93814 95.9927Z",
    fill: "#A7A3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9116 96.2927L13.9869 72.2031L5.625 45.8965H20.6239L23.2862 72.2031L23.5861 94.0756L27.7483 96.2927H16.9116Z",
    fill: "#CECDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5317 24.3545L30.2434 17.8317C30.8416 16.7102 32.5612 14.2055 36.2995 14.6876C36.7892 14.7507 36.0743 15.3596 36.3743 15.5848C36.6789 15.8135 37.9582 15.7949 38.1313 16.0373C38.8579 17.0545 38.294 18.5572 37.8043 19.294C37.7082 19.4387 37.5521 19.528 37.3815 19.5609L33.2812 20.3528C32.9815 20.4106 32.7468 20.6443 32.6877 20.9437L31.4267 27.3262C30.5776 31.6241 25.9225 33.9868 21.9521 32.1348L18.6173 30.5793C17.8073 30.0684 16.1575 29.0242 16.0378 28.9345C15.9182 28.8448 11.4771 19.1027 9.27148 14.2429L10.9142 14.8384C11.8048 15.1612 12.6261 15.6498 13.3348 16.2784L23.0834 24.925C24.153 25.8736 25.8246 25.5971 26.5317 24.3545Z",
    fill: "#EAE9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3096 9.76024H6.59278L11.7673 4.28522L12.6635 2.3735C12.8002 2.08186 12.736 1.73451 12.4745 1.5465C11.6565 0.958429 10.0667 0.133857 8.16762 0.0105417C5.8578 -0.139447 4.75541 1.34823 4.49294 2.11082C4.11796 2.11063 3.33265 2.67303 2.95555 3.31073C1.74522 5.35749 3.09173 8.26021 4.00841 9.60411C4.07623 9.70354 4.18925 9.76024 4.3096 9.76024Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7107 2.43586L12.2177 4.28527L14.0175 7.43503L13.5676 7.8475C13.8675 8.87242 14.0775 11.0873 12.5176 11.7472C12.0252 11.9555 11.5998 12.0634 11.2322 12.1566C10.5875 12.3201 10.121 12.4384 9.78367 12.9743L9.78691 12.9741C9.37444 13.7615 10.0351 14.5152 10.1994 14.6239C11.8776 15.2533 12.6903 16.3125 13.3797 17.967L1.3418 17.3237C1.8892 16.4125 2.57416 15.7669 3.18413 15.192C3.82242 14.5903 4.3786 14.0661 4.60911 13.3959C4.75619 12.8329 4.77179 12.2376 4.6466 11.6573L4.23732 9.75986H5.76815L7.53051 7.43503C7.23053 7.01006 6.85556 6.07014 7.75549 5.71016C8.39356 5.45494 8.818 5.78783 9.05553 6.16356C9.08028 6.20271 9.20282 6.16858 9.19734 6.12259L9.06789 5.03521C9.39287 4.86023 9.88533 4.33027 9.25538 3.61032C9.54022 3.40217 10.1266 2.91364 10.4488 2.45276C10.5104 2.36477 10.6429 2.35262 10.7107 2.43586Z",
    fill: "#EAE9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6227 45.8966L18.752 31.2903L20.6602 32.96C20.0903 29.5103 21.2977 25.3481 21.9726 23.6982L12.6358 15.7113L11.4359 15.0739L10.1985 14.6239C8.43394 14.2526 4.56052 13.8465 3.18326 15.1919C1.61504 16.67 -0.448872 18.6153 0.603576 24.3416C1.72672 30.4525 2.58658 40.7232 2.58658 47.9589C7.43287 49.8796 10.2307 48.7808 13.2935 47.578C15.373 46.7612 17.5747 45.8966 20.6227 45.8966Z",
    fill: "#817DB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9449 6.03961C11.9449 6.16244 11.8453 6.262 11.7225 6.262C11.5996 6.262 11.5001 6.16244 11.5001 6.03961C11.5001 5.91679 11.5996 5.81722 11.7225 5.81722C11.8453 5.81722 11.9449 5.91679 11.9449 6.03961Z",
    fill: "#55489E",
    stroke: "#55489E",
    strokeWidth: 0.132976
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.373 5.47669C11.4782 5.39421 11.6057 5.3454 11.7391 5.33663C11.8724 5.32787 12.0053 5.35957 12.1203 5.42758",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.373 5.47669C11.4782 5.39421 11.6057 5.3454 11.7391 5.33663C11.8724 5.32787 12.0053 5.35957 12.1203 5.42758",
    stroke: "#55489E",
    strokeWidth: 0.206341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35791 6.56995C8.42325 6.65682 8.45247 6.75124 8.44173 6.84084C8.431 6.93043 8.38081 7.01103 8.29775 7.07209",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35791 6.56995C8.42325 6.65682 8.45247 6.75124 8.44173 6.84084C8.431 6.93043 8.38081 7.01103 8.29775 7.07209",
    stroke: "#A7A3CD",
    strokeWidth: 0.224983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7312 8.36283L12.8257 8.58172C12.6382 8.95669 12.8632 9.93161 12.2257 9.93161C11.5883 9.93161 11.1383 9.21917 11.0633 8.8442C11.0449 8.75227 11.0519 8.66973 11.0736 8.59767C11.1507 8.34212 11.4695 8.31048 11.7312 8.36283Z",
    fill: "#06061A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9019 7.41919L13.002 8.05664",
    stroke: "#A7A3CD",
    strokeWidth: 0.224983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySectionStanding);
export default __webpack_public_path__ + "static/media/empty-section-standing.81468720.svg";
export { ForwardRef as ReactComponent };